import React, { Component } from "react";
import Box from "@mui/material/Box";
import colors from "./Colors";
// import Plot from 'react-plotly.js';
import "./Styles/NFP.css";
// import { DataGrid } from '@mui/x-data-grid';
import CsvDownload from "react-json-to-csv";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
// import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import TableHealth from "./Containers/TableHealth.js";

import SplashScreen from "./SplashScreen.tsx";
import Draggable from "react-draggable";

export class HEALTH extends Component {
  constructor(props) {
    super(props);
    this.state = {
      active: false,
      addr: "",
      data: {
        count: 0,
        sales: 0,
      },
      sales: {
        x: [],
        y: [],
      },
      bundle: {
        x: [],
        y: [],
      },
      trans: {
        row: [{}],
        column: [],
        transactions: 0,
        mimShareAmount: 0,
        paymentInit: 0,
      },
      searchValue: "",
      searchdata: [],
      lock: false,
      done: [],
      id: sessionStorage.getItem("id") || "",
      secret: sessionStorage.getItem("authkey") || "",
      level: sessionStorage.getItem("level"),
      selectedrequests: [],
      totalamount: 0,
      payi: true,
      payc: true,
      ins: "",
      re: "",
      payable: 0,
      isFlipped: false,
      loadingii: false,
    };
  }

 componentDidMount() {
  const addrr = "https://app.myimpactmeter.com/api/v2/prod/admin/adminPortal/getItemByKey";

  fetch(addrr, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ key: "sfoHealthTxs" }),
  })
    .then((response) => response.json())
    .then((res) => {
      const data = res?.data || [];

      const transactions = data.length;

      const mimShareAmount = data.reduce((total, item) => {
        const val = parseFloat(item.mimShareAmount);
        return total + (isNaN(val) ? 0 : val);
      }, 0);

      const paymentInit = data.filter((item) => item.paymentInit === false).length;

      const payable = data.reduce((sum, item) => {
        if (item.paymentComplete !== true && item.payableAmount != null) {
          return sum + item.payableAmount;
        }
        return sum;
      }, 0);

      const column = data[0] ? Object.keys(data[0]) : [];

      this.setState({
        trans: {
          row: data,
          column: column,
          transactions,
          mimShareAmount,
          paymentInit,
        },
        payable,
        loadingii: true,
      });
    })
    .catch((error) => {
      console.error("Fetch error:", error);
      this.setState({ loadingii: true }); // optional: set loading even if failed
    });
}


  upd() {
     const addrr = "https://app.myimpactmeter.com/api/v2/prod/admin/adminPortal/getItemByKey";

  fetch(addrr, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ key: "sfoHealthTxs" }),
  })
    .then((response) => response.json())
    .then((res) => {
      const data = res?.data || [];

      const transactions = data.length;

      const mimShareAmount = data.reduce((total, item) => {
        const val = parseFloat(item.mimShareAmount);
        return total + (isNaN(val) ? 0 : val);
      }, 0);

      const paymentInit = data.filter((item) => item.paymentInit === false).length;

      const payable = data.reduce((sum, item) => {
        if (item.paymentComplete !== true && item.payableAmount != null) {
          return sum + item.payableAmount;
        }
        return sum;
      }, 0);

      const column = data[0] ? Object.keys(data[0]) : [];

      this.setState({
        trans: {
          row: data,
          column: column,
          transactions,
          mimShareAmount,
          paymentInit,
        },
        payable,
        loadingii: true,
      });
    })
    .catch((error) => {
      console.error("Fetch error:", error);
      this.setState({ loadingii: true }); // optional: set loading even if failed
    });
  }



  UpdateInputSearch(evt) {
    const val = evt.target.value;
    this.setState({
      searchValue: val,
    });
  }

  UpdateInputIns(evt) {
    const val = evt.target.value;
    this.setState({
      ins: val,
    });
  }

  UpdateInputre(evt) {
    const val = evt.target.value;
    this.setState({
      re: val,
    });
  }

  processcheck(ids) {
    this.setState({ selectedrequests: ids });
    var temp = 0;
    for (let index = 0; index < this.state.trans.row.length; index++) {
      if (ids.includes(this.state.trans.row[index]["id"])) {
        temp += this.state.trans.row[index]["payableAmount"];
      }
    }
    this.setState({ totalamount: temp });
    return;
  }

  batch() {
    const postBody = {
      ids: this.state.selectedrequests,
      // ids: this.state.id,
      secret: this.state.secret,
      instrumentNo: this.state.ins,
      remarks: this.state.re,
      paymentInit: this.state.payi,
      paymentComplete: this.state.payc,
    };

    const requestMetadata = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
body: JSON.stringify({
  key: "sfoHealthTxsUpdate",
  data: postBody,
}),    };
    fetch("httpS://app.myimpactmeter.com/api/v2/prod/admin/adminPortal/setItemByKey", requestMetadata)
      .then((res) => res.json())
      .then((result) => {
        alert("Edited: " + result["message"]);
        if (result["message"] === "success") {
          var collection = document.getElementsByClassName("prompt");
          collection[0].style.display = "none";
          collection = document.getElementsByClassName("disable");
          collection[0].style.display = "none";
          this.upd();
          this.componentDidMount();
        }
      });
  }

  MD(event) {
    this.setState({ movect: true });
  }
  MU(event) {
    this.setState({ movect: false });
  }

  MM(event) {
    if (this.state.movect) {
      var collection = document.getElementsByClassName("prompt");
      collection[0].style.left = event.pageX - 250 + "px";
      collection[0].style.top = event.pageY - 250 + "px";
    }
  }

  handleClickflip() {
    console.log(this.state.isFlipped);
    this.setState({ isFlipped: !this.state.isFlipped });
  }

  render() {

    return (
      <div>
        {this.state.loadingii === false ? (
          <SplashScreen />
        ) : (
          <div>
            <div className="tableFR">
              <div
                className={`table-container ${
                  this.state.isFlipped ? "flipped" : ""
                }`}
              >
                <div className="back-content">
                  <Box
                    sx={{
                      width: "97%",
                      height: "15%",
                      backgroundColor: colors["grocery"],
                    }}
                    className="das-body"
                  >
                    <div className="allcontent">
                      <Box
                        sx={{
                          backgroundColor: colors["cream"],
                          borderRadius: "20px",
                          borderColor: "black",
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                        className="das-gro-sales"
                      >
                        <p className="das-gro-count-c">
                          {this.state.sales["y"].reduce(
                            (partialSum, a) => parseFloat(partialSum) + a,
                            0
                          )}
                        </p>
                        <p className="das-gro-count-t">Total Sales (PKR)</p>
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: colors["cream"],
                          borderRadius: "20px",
                          borderColor: "black",
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                        className="das-gro-count"
                      >
                        <p className="das-gro-count-c">
                          
                          {
                            this.state.sales["y"][
                              this.state.sales["y"].length - 1
                            ]
                          }
                        </p>
                        <p className="das-gro-count-t">
                          Showing sales of{" "}
                          
                          {
                            this.state.sales["x"][
                              this.state.sales["y"].length - 1
                            ]
                          }
                        </p>
                      </Box>

                      <Box
                        sx={{
                          backgroundColor: colors["cream"],
                          borderRadius: "20px",
                          borderColor: "black",
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                        className="das-gro-co-req"
                      >
                        <p className="das-gro-count-c">
                          {this.state.trans["transactions"]}
                        </p>
                        <p className="das-gro-count-t">
                          Total no of Transactions
                        </p>
                      </Box>

                      <Box
                        sx={{
                          backgroundColor: colors["cream"],
                          borderRadius: "20px",
                          borderColor: "black",
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                        className="das-gro-co-req-2"
                      >
                        <p className="das-gro-count-c">
                          {this.state.trans["paymentInit"]}
                        </p>
                        <p className="das-gro-count-t">Total no of unpaid</p>
                      </Box>

                      <Box
                        sx={{
                          backgroundColor: colors["cream"],
                          borderRadius: "20px",
                          borderColor: "black",
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                        className="das-gro-co-req-3"
                      >
                        <p className="das-gro-count-c">
                          {this.state.trans["mimShareAmount"]}
                        </p>
                        <p className="das-gro-count-t">Total mimShare (PKR)</p>
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: colors["cream"],
                          borderRadius: "20px",
                          borderColor: "black",
                          borderWidth: "1px",
                          borderStyle: "solid",
                        }}
                        className="das-gro-co-req-3"
                      >
                        <p className="das-gro-count-c">
                          {parseFloat(this.state.payable).toLocaleString()}
                        </p>
                        <p className="das-gro-count-t">Total Payable (PKR)</p>
                      </Box>
                    </div>
                  </Box>
                </div>
                <TableHealth
                  data={this.state.trans.row}
                  onSelectionChanged={this.processcheck.bind(this)}
                />
              </div>
            </div>

            <div className="disable"></div>
            {/* <Plot
                        className='nfp-plot'
                        data={[
                        {
                            type: 'bar',
                            color:'red',
                            x: this.state.sales['x'],
                            y: this.state.sales['y'],
                            marker: {
                                color: '#FE5F55',
                                opacity: 0.9,
                                line: {
                                color: 'rgb(8,48,107)',
                                width: 1.5
                                }
                            }
                        }, 
                        ]}
                        layout={ {
                        title: 'Sales'
                        }}
                        
                    /> */}
            {this.state.level === "5" || this.state.level === "10" ? (
              <Box
                sx={{
                  backgroundColor: colors["cream"],
                }}
                className="das-gro-co-init"
              >
                {/* <TextField
                  inputProps={{
                    style: {
                      top: "5px",
                      width: "200px",
                      padding: "10px",
                      fontSize: 15,
                    },
                  }}
                  InputLabelProps={{
                    style: { fontSize: 9 },
                  }}
                  id="outlined-basic"
                  className="texttrans"
                  value={this.state.searchValue}
                  onKeyDown={this.UpdateInputValue.bind(this)}
                  onChange={this.UpdateInputSearch.bind(this)}
                  label="Single only TransactionID (Hit Enter to process)"
                  variant="outlined"
                /> */}

                 <Box
                  sx={{
                    backgroundColor: colors["cream"],
                  }}
                  className="das-gro-co-req-3"
                >
                  <p
                    className="das-gro-count-c"
                    style={{ fontWeight: "bold", fontSize: "18px" }}
                  >
                    {parseFloat(this.state.totalamount).toLocaleString()} -
                    Total Selected Payable (PKR)
                  </p>
                </Box>
                <Button
                  variant="contained"
                  color="success"
                  className="bat"
                  onClick={this.handleClickflip.bind(this)}
                >
                  Stats
                </Button>
                <Button
                  variant="contained"
                  color="success"
                  className="bat"
                  onClick={() => {
                    var collection = document.getElementsByClassName("prompt");
                    collection[0].style.display = "block";
                    collection = document.getElementsByClassName("disable");
                    collection[0].style.display = "block";
                  }}
                >
                  Batch Process
                </Button>
                <CsvDownload
                  {...{
                    data: this.state.trans.row,
                    filename: "Report.csv",
                    delimiter: ",",
                  }}
                  className="download"
                />
              </Box>
            ) : (
              <div></div>
            )}
            <Draggable>
              <div
                className="prompt"
                onMouseDown={this.MD.bind(this)}
                onMouseUp={this.MU.bind(this)}
                onMouseMove={this.MM.bind(this)}
              >
                <h1
                  className="cross"
                  onClick={() => {
                    var collection = document.getElementsByClassName("prompt");
                    collection[0].style.display = "none";
                    collection = document.getElementsByClassName("disable");
                    collection[0].style.display = "none";
                  }}
                >
                  X
                </h1>
                <h1 className="head1">TO PAY = {this.state.totalamount}</h1>
                <TextField
                  id="outlined-basic"
                  className="texttrans2"
                  value={this.state.ins}
                  onKeyDown={this.UpdateInputIns.bind(this)}
                  onChange={this.UpdateInputIns.bind(this)}
                  label="Instrument Number"
                  variant="outlined"
                />
                <br></br>
                <TextField
                  id="outlined-basic"
                  className="texttrans3"
                  value={this.state.re}
                  onKeyDown={this.UpdateInputre.bind(this)}
                  onChange={this.UpdateInputre.bind(this)}
                  label="Remarks"
                  variant="outlined"
                />
                <FormControlLabel
                  className="checkx"
                  control={
                    <Checkbox
                      checked={this.state.payi}
                      onChange={() => {
                        this.setState({ payi: !this.state.payi });
                      }}
                    />
                  }
                  label="Payment Init"
                />
                <FormControlLabel
                  className="checkx"
                  control={
                    <Checkbox
                      checked={this.state.payc}
                      onChange={() => {
                        this.setState({ payc: !this.state.payc });
                      }}
                    />
                  }
                  label="Payment Completed"
                />
                <Button
                  variant="contained"
                  color="success"
                  className="b1"
                  onClick={this.batch.bind(this)}
                >
                  Update
                </Button>
              </div>
            </Draggable>
          </div>
        )}
      </div>
    );
  }
}

export default HEALTH;
